import BOImageCreate from "../components/pages/boimages/BOImageCreatorPage";
import BOImagesDetailsPage from "../components/pages/boimages/BOImagesDetailsPage";
import BOImagesPage from "../components/pages/boimages/BOImagesPage";

const routes = [
    {
        path: "/boimages",
        element: <BOImagesPage />
    },
    {
        path: "/boimages/create",
        element: <BOImageCreate />
    },
    {
        path: "/boimages/edit/:BOimageID",
        element: <BOImageCreate />
    },
    {
        path: "/boimages/:BOimageID",
        element: <BOImagesDetailsPage />
    }
];

export default routes;
